import { render } from "./Flex.vue?vue&type=template&id=66dd9943&ts=true"
import script from "./Flex.vue?vue&type=script&lang=ts"
export * from "./Flex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.41_vue@3.5.14_typescript@5.5.4__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__